import type { SupabaseClient } from "@supabase/supabase-js";
import { createClient } from "@supabase/supabase-js";

const FALLBACK_SUPABASE_URL = "https://jrguywsbcbjyljewbkgt.supabase.co";
const FALLBACK_PUBLISHABLE_KEY =
  "sb_publishable_mrkzncZrgxnud7L-guZTqg_76Vg7b1K";

const rawUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const rawKey = import.meta.env.VITE_SB_PUBLISHABLE_KEY as string | undefined;

export const SUPABASE_URL =
  !rawUrl ||
  rawUrl.includes("127.0.0.1") ||
  rawUrl.includes("localhost")
    ? FALLBACK_SUPABASE_URL
    : rawUrl;

export const SUPABASE_PUBLISHABLE_KEY =
  !rawKey || rawKey === "sb_publishable_ACJWlzQHlZjBrEguHvfOxg_3BJgxAaH"
    ? FALLBACK_PUBLISHABLE_KEY
    : rawKey;

let supabaseClient: SupabaseClient | null = null;

export const getSupabaseClient = () => {
  if (!supabaseClient) {
    supabaseClient = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
  }
  return supabaseClient;
};
